import { render, staticRenderFns } from "./ListagemTransportadoraHeader.vue?vue&type=template&id=9dacaade"
import script from "./ListagemTransportadoraHeader.vue?vue&type=script&lang=js"
export * from "./ListagemTransportadoraHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports